module.exports = __webpack_public_path__ + "img/icon_main_11.4c77b8a8.svg";